(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-directory"] && !Shopify.designMode) return;
  try {
    
	(function () {
		function getOffset(nav) {
			var offset = 16;
			var headerContent = document.querySelector('[data-header-container]');
			if (headerContent && headerContent.closest('[data-header-sticky]')) {
				var rootStyle = document.documentElement.style;
				var headerHeight = parseInt(rootStyle.getPropertyValue('--header-height'), 10);
				if (!headerHeight) headerHeight = headerContent.getBoundingClientRect().height;
				offset += headerHeight || 0;
			}
			if (nav && window.getComputedStyle(nav).position === 'sticky') {
				offset += nav.getBoundingClientRect().height;
			}
			return offset;
		}

		document.addEventListener('click', function (event) {
			var link = event.target.closest('[data-brand-directory-nav] a[href^="#"]');
			if (!link) return;

			var id = link.getAttribute('href').slice(1);
			var target = document.getElementById(id);
			if (!target) return;

			event.preventDefault();

			var nav = link.closest('[data-brand-directory-nav]');
			var top = target.getBoundingClientRect().top + window.pageYOffset - getOffset(nav);
			var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

			window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });

			if (history.replaceState) {
				history.replaceState(null, '', '#' + id);
			}

			if (!target.hasAttribute('tabindex')) {
				target.setAttribute('tabindex', '-1');
			}
			target.focus({ preventScroll: true });
		});
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-essentials"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('brand-essentials')) {
		customElements.define(
			'brand-essentials',
			class BrandEssentials extends HTMLElement {
				connectedCallback() {
					this.addEventListener('submit', this.onSubmit);
				}

				disconnectedCallback() {
					this.removeEventListener('submit', this.onSubmit);
				}

				async onSubmit(event) {
					const form = event.target.closest('[data-be-form]');
					const core = window.themeCore;
					if (!form || !core || !core.CartApi) return; // falls back to normal /cart/add POST

					event.preventDefault();
					const button = form.querySelector('button[type="submit"]');
					button && button.setAttribute('aria-busy', 'true');

					try {
						await core.CartApi.makeRequest(core.CartApi.actions.ADD_TO_CART, {
							id: Number(form.elements.id.value),
							quantity: Number(form.elements.quantity.value) || 1,
						});
						await core.CartApi.makeRequest(core.CartApi.actions.GET_CART);
					} catch (error) {
						const notify = core.CartNotificationError;
						if (notify && error && error.description) {
							notify.addNotification(error.description);
							notify.open();
						}
					} finally {
						button && button.removeAttribute('aria-busy');
					}
				}
			}
		);
	}

  } catch(e) { console.error(e); }
})();
})();
